// unicode letter: https://www.toptechskills.com/elixir-phoenix-tutorials-courses/how-to-match-any-unicode-letter-with-regex-elixir/
const regex = /\p{L}/u

export default function isWord (word) {
  return regex.test(word)
}
